import React from 'react';
import { useFirebaseData } from '../../hooks/useFirebaseData';

export default function Aboutus() {
  const { data: aboutusData, loading } = useFirebaseData('aboutus');

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // Sort the data to maintain the order: VISION, MISSION, GOALS, VALUES
  const sortOrder = ['VISION', 'MISSION', 'GOALS', 'VALUES'];
  const sortedData = [...(aboutusData || [])].sort((a, b) => 
    sortOrder.indexOf(a.title) - sortOrder.indexOf(b.title)
  );

  return (
    <div className='grid gap-4 sm:grid-cols-1 md:grid-cols-2 xl:grid-cols-2 text-center py-12 box-border w-full max-w-6xl mx-auto'>
      {sortedData.map((item, index) => (
        <div key={item.id || index} className='w-full py-4 border-b-2 md:border-r-2 my-14'>
          <div className='text-[20px] font-bold font-[roboto]'>{item.title}</div>
          <br />
          <div className='text-[#4c4c4c] font-[roboto] px-10 whitespace-pre-wrap'>
            {item.description}
          </div>
        </div>
      ))}
    </div>
  );
}
